import { useWebsiteSettings } from 'client/store'
import { PaddingType } from 'common/types/styleTypes'
import { WebsiteButtonAndFormFieldTypes } from 'src/shared/types/website-settings-types'
import { buttonAndFormFieldSelectorMap } from 'src/editor/store/website-settings/website-settings-selector'

export const useCalculatePadding = ({
  padding,
  mobilePadding,
  type,
}: {
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  type: WebsiteButtonAndFormFieldTypes
}) => {
  const websiteSettings =
    useWebsiteSettings(buttonAndFormFieldSelectorMap[type]) || {}
  const {
    paddingTop: globalPaddingTop,
    paddingRight: globalPaddingRight,
    paddingBottom: globalPaddingBottom,
    paddingLeft: globalPaddingLeft,
  } = (websiteSettings.padding as Partial<PaddingType>) || {}

  return {
    calculatedPadding: {
      mobile: {
        paddingTop: (mobilePadding?.paddingTop ?? globalPaddingTop) as number,
        paddingRight: (mobilePadding?.paddingRight ??
          globalPaddingRight) as number,
        paddingBottom: (mobilePadding?.paddingBottom ??
          globalPaddingBottom) as number,
        paddingLeft: (mobilePadding?.paddingLeft ??
          globalPaddingLeft) as number,
      },
      desktop: {
        paddingTop: (padding?.paddingTop ?? globalPaddingTop) as number,
        paddingRight: (padding?.paddingRight ?? globalPaddingRight) as number,
        paddingBottom: (padding?.paddingBottom ??
          globalPaddingBottom) as number,
        paddingLeft: (padding?.paddingLeft ?? globalPaddingLeft) as number,
      },
    },
  }
}
